import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import * as khoConstant from './constants'
import * as khoAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import ViewTraThuong from '../../views/KhachHang/_ViewTraThuong';
import * as khachhangConstant from '../../views/KhachHang/constants'
import * as khachhangAction from '../../views/KhachHang/actions'
import * as common from '../../lib/common'
class Kho extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      list: [],
      keyword: '',
      TrangThaiId: '',
      per_page: 20,
      page: 1,
      total_record: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ TrangThaiId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  fetchList = () => {
    const { khoListRequest } = this.props

    var requestData = {
      StoreId: this.state.StoreId,
      keyword: this.state.keyword,
      status: this.state.TrangThaiId,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return khoListRequest(requestData);
  }
  search = () => {
    if (this.props.kho.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  refresh = () => {
    this.setState({
      StoreId: this.state.StoreId,
      keyword: '',
      TrangThaiId: '',
      page: this.state.page,
      per_page: this.state.per_page
    }, () => {
      if (this.props.kho.listRequesting) {
        return false;
      }
      return this.fetchList()
    })
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditKhoItem = (item) => {
    this.props.history.push('/kho-edit?kho=' + (item.KhoId || ""));
  }
  ViewKhoItem = (e, khID) => {
    e.preventDefault()
    this.props.history.push('/kho-edit?kho=' + (khID || ""));
  };
  componentDidMount() {
    this.fetchList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.kho.type == khoConstant.KHO_LIST_SUCCESS) {
      let { list, item } = nextProps.kho;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  viewTraThuong = (obj) => {
    obj.DiemTichLuy = parseFloat(obj.DiemTichLuy || 0)
    obj["MaxValue"] = obj.DiemTichLuy
    obj["SoDiemTraThuong"] = obj.DiemTichLuy
    obj["SoTienTraThuong"] = 0
    obj["NgayTraThuong"] = common.currentDate()
    obj["LoaiTraThuong"] = khachhangConstant.LoaiTraThuong.Point
    obj["Loai"] = khachhangConstant.LoaiKhachHang.Store
    obj["GhiChu"] = ''
    this.setState({ modalUpdateTraThuong: true, objTraThuong: obj })
  };
  viewTraThuongDs = (obj) => {
    obj.DsTichLuy = parseFloat(obj.DsTichLuy || 0)
    obj["MaxValue"] = obj.DsTichLuy
    obj["SoDiemTraThuong"] = obj.DsTichLuy
    obj["SoTienTraThuong"] = 0
    obj["NgayTraThuong"] = common.currentDate()
    obj["LoaiTraThuong"] = khachhangConstant.LoaiTraThuong.Money
    obj["Loai"] = khachhangConstant.LoaiKhachHang.Store
    obj["GhiChu"] = ''
    this.setState({ modalUpdateTraThuong: true, objTraThuong: obj })
  }
  handleCloseTraThuong = () => {
    this.setState({ modalUpdateTraThuong: false })
  };
  TraThuongKhachHang = (obj) => {
    var requestData = {
      khachHangId: obj.KhoId,
      loai: obj.Loai,
      loaiTraThuong: obj.LoaiTraThuong,
      soTien: obj.SoTienTraThuong,
      diem: obj.SoDiemTraThuong,
      ghiChu: obj.GhiChu,
      ngayTraThuong: obj.NgayTraThuong.unix()
    };
    this.props.khachhangTraThuongRequest(requestData, () => {
      this.handleCloseTraThuong();
      this.search();
    })
  }
  render() {
    const {
      handleSubmit,
      kho: {
        listRequesting,
        isRequesting,
        list,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." open={true}>
              <Row>
                <Col sm="4" className="mb-2 p-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend">Trạng thái</InputGroupAddon>
                    <select className="form-control" value={this.state.TrangThaiId} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={1}>Hoạt động</option>
                      <option value={0}>Ngừng hoạt động</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="8" className="mb-2 p-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Tìm kiếm theo</InputGroupAddon>
                    <Input name="keyword" placeholder="Mã, Tên, địa chỉ, email, điện thoại" value={this.state.keyword} onChange={this.handleSearchChange.bind(this, "keyword")} />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <ButtonExt className="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditKhoItem({})}
                permission={BtnPermissions.Kho.ADD_OR_UPDATE} />
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="40" className="text-center">#</th>
                    <th scope="col" className="text-center">Mã kho</th>
                    <th scope="col" className="text-left">Tên kho</th>
                    <th scope="col" className="text-right">Điểm</th>
                    <th scope="col" className="text-right">Doanh số</th>
                    <th scope="col" width="30" className="text-center">Cấp</th>
                    <th scope="col" width="120" className="text-center">Điện thoại</th>
                    <th scope="col" width="150" className="text-center">Người đại diện</th>
                    <th scope="col" className="text-left">Địa chỉ</th>
                    <th scope="col" width="120" className="text-center">Email</th>
                    <th scope="col" className="text-center">Điểm</th>
                    <th scope="col" width="80" className="text-center">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-center">{res.Ma}</td>
                        <td className="text-left">
                          <a href='#' onClick={(e) => this.ViewKhoItem(e, res.KhoId)}>{res.Ten}</a>
                        </td>
                        <td className="text-right font-weight-bold text-primary">
                          {parseFloat(res.DiemTichLuy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                        </td>
                        <td className="text-right font-weight-bold text-primary">
                          <div>{parseFloat(res.DsTichLuy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</div>
                        </td>
                        <td className="text-center">{res.CapKho}</td>
                        <td className="text-center">{res.DienThoai}</td>
                        <td className="text-center">{res.NguoiDaiDien}</td>
                        <td className="text-left">{res.DiaChi}</td>
                        <td className="text-center">{res.Email}</td>
                        <td className="text-right">
                          {parseFloat(res.DiemTichLuy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                          {
                            (res.DiemTichLuy || 0) > 0 ?
                              <ButtonExt btnClass="pull-right mr-1"
                                size="xs"
                                color="primary" 
                                iconClass="fa-money"
                                displayText="Trả thưởng"
                                btnClick={() => this.viewTraThuong(res)}
                                permission={BtnPermissions.TraThuongDiem.TRATHUONG} />
                              : ""
                          }
                        </td>
                        <td className="text-center">
                          {res.IsActive == 0 ? <span className="text-danger"><i className="fa fa-close"></i></span> : <span className="text-success"><i className="fa fa-check"></i></span>}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="11">Trạng thái:
                      <span className="text-success ml-1 mr-2"><i className="fa fa-check"></i> = Đang hoạt động</span>
                      <span className="text-danger mr-3"><i className="fa fa-close"></i> = Dừng hoạt động</span>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="11">Cấp:
                      <span className="text-danger ml-1 mr-2"><i className="fa">1</i> = Cấp công ty</span>
                      <span className="text-danger"><i className="fa">2</i> = Cấp đại lý</span>
                    </td>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <ViewTraThuong item={this.state.objTraThuong}
            isRequesting={isRequesting}
            isOpen={this.state.modalUpdateTraThuong}
            onClose={this.handleCloseTraThuong}
            TraThuongKhachHang={this.TraThuongKhachHang}
            errors={errors}
            messages={messages}
          />
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  kho: state.kho,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  khoListRequest: khoAction.khoListRequest,
  khoUpdateRequest: khoAction.khoUpdateRequest,
  khachhangTraThuongRequest: khachhangAction.khachhangTraThuongRequest
})(Kho)
const formed = reduxForm({
  form: 'kho',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/Kho/Kho.js